<script>
  import I18n from './G_I18n.svelte'
  export let msg=''
</script>
<div class="container">
  <i class="fa-solid fa-spinner-third fa-spin fa-2x text-muted fa-fw"></i>
  <p><I18n>{msg}</I18n></p>
</div>